import { calculateAudioLevel } from './calculateAudioLevel';
import { subscribeForAudioBuffer } from './subscribeForAudioBuffer';

type Unsubscribe = () => void;

const BUFFER_SIZE = 5000;
const SMOOTHING_FACTOR = 0.5;
/**
 * @description To be used for getting audio level from the media stream.
 * @param audioTrack Audio track to listen to
 * @param callback Get audio level updates
 * @returns {Unsubscribe} - Unsubscribe function
 */
export const subscribeForAudioLevel = async (
  audioTrack: MediaStreamTrack,
  callback: (level: number) => void,
): Promise<Unsubscribe> => {
  let value = 0;
  const unsubscribe = await subscribeForAudioBuffer(
    audioTrack,
    (audioBuffer: Float32Array) => {
      value = calculateAudioLevel(audioBuffer, value, SMOOTHING_FACTOR);
      callback(value);
    },
    BUFFER_SIZE,
  );
  return unsubscribe;
};
